export function dispatchCustomEvent(
  eventName: string,
  detail: object,
  { bubbles = true, composed = true } = {},
) {
  const event = new CustomEvent(eventName, {
    detail,
    bubbles,
    composed,
  });
  document.dispatchEvent(event);
}
